import { Grid, Typography, Skeleton, Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router';

interface LocationProfileDescriptionProps {
  desc?: string;
  loading?: boolean;
  /** Public supplier profile path (/supplier/{shortId}/{slug}); the "More yards" link renders only when set. */
  supplierProfileUrl?: string | null;
  /** Empty for anonymous visitors (the API masks it), so the link text falls back to a generic label. */
  supplierName?: string;
}

const LocationProfileDescription = ({ desc, loading, supplierProfileUrl, supplierName }: LocationProfileDescriptionProps) => {
  return <Grid container direction='column' className='ss-profile-desc-container'>
    {loading ? <Skeleton width={"15%"} /> : <Typography className='ss-profile-desc-title' >Description</Typography>}
    {loading ? <Skeleton width={"70%"} /> : <Typography className="ss-profile-desc">{desc}</Typography>}
    {!loading && supplierProfileUrl && (
      <Typography className="ss-profile-desc">
        <Link component={RouterLink} to={supplierProfileUrl}>
          More yards from {supplierName || 'this supplier'}
        </Link>
      </Typography>
    )}
  </Grid>
}

export default LocationProfileDescription;
